export function fullAddress(task) {
  if (task) {
    const { street, streetAddress, city, state, zipCode, zipcode } = task.home || task;
    if ((street || streetAddress) && city && state && (zipCode || zipcode)) {
      return `${street ?? streetAddress}, ${city}, ${state} ${zipCode ?? zipcode}`;
    }
  }
  return null;
}
